import { z } from "zod";
import { DemoIdentitySchema } from "../demos/registry";

export const SOCIAL_FEATURE_FLAG = "feature-social";
export const DemoSessionResponseSchema = DemoIdentitySchema;
export type DemoSessionResponse = z.infer<typeof DemoSessionResponseSchema>;
export const DemoCapabilitiesResponseSchema = DemoIdentitySchema.extend({
  social: z.boolean(),
  refreshAfterMs: z.number().int().positive(),
}).strict();
export type DemoCapabilitiesResponse = z.infer<
  typeof DemoCapabilitiesResponseSchema
>;
